<template>
  <v-container fluid>
    <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers" :items="Facture"
      :items-per-page="5" sort-by="">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des factures éditer</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date création début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="periodStartDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date création fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="periodEndDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete outlined color="#0482fb" :items="userFile" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat background-color="grey lighten-4"
                      label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                    <!-- <v-text-field outlined color="#0482fb" label="Nom raison sociale" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                      background-color="grey lighten-4"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Numéro client" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="customerNumber" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Numéro facture DAYO GS" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="invoiceNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Numéro facture compagnie" class="pt-5 pa-2"
                      v-model="companyInvoiceNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu elevation="0" right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
              <v-icon color="success" size="30">mdi-forwardburger</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on" color="warning">mdi-license</v-icon>
                </v-btn>
              </template>
              <span>Réclamation de Prime au client</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                    @click="editItems(item)">mdi-cash-register</v-icon>
                </v-btn>
              </template>
              <span>Réclamation de commission à la compagnie</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" color="error" v-bind="attrs" v-on="on"
                    @click="linkModalFacture(item)">mdi-vector-link</v-icon>
                </v-btn>
              </template>
              <span>Liaison de facture</span>
            </v-tooltip>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-dialog v-model="printDeclaration" width="1000px">
      <v-card style="border-top: 10px solid #0482fb">
        <section style="margin-right:50px;margin-left:50px; padding-bottom:50px;padding-top:50px;">
          <v-row>
            <v-spacer></v-spacer>
            <v-btn color="error" class="mt-5 ml-2 mr-2 white--text" :loading="loading ? '#0482fb' : null" pill
              @click="generateReport()">Imprimer sous format PDF</v-btn>
          </v-row>
          <div id="document" ref="document">
            <div
              style="display: flex;flex-direction: row;margin-Top:40px;border-Bottom:2px solid black;padding-bottom:20px;">
              <div style="background-color:white;">
                <img src="../assets/logo.jpg" alt="DAYO Gras Savoye" width="150" height="70" />
              </div>
              <div style="width:100%;display: flex;background-color:white;justify-content:center;align-items:center;">
                <div style="display: flex;flex-direction:column;">
                  <div style="font-size:20px;font-Weight:bold ; background-color:white;">
                    DAYO GRAS SAVOYE BENIN
                  </div>
                  <div style="background-color:white;">
                    Courtier en assurances
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px">
              <div style="font-weight:bold;margin-top:10;margin-bottom:90;margin-right:40px;">
                CLIENT N° :
              </div>
              <div style="margin-top:10;margin-bottom:90">
                {{ this.contractModal.customerNumber }}
              </div>
            </div>
            <div style="border-bottom:2px solid black;padding-bottom:20px;">
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Raison Sociale :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.name }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Adresse :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.location }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Province :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.city }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    N.I.F :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.NIF }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    STAT :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.STAT }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    RCS :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.RCA }}
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;flex-direction:row;">
              <div style="margin-top:10px;margin-bottom:10px;flex: 1;">
                N° FACTURE DAYO GS :
                {{ this.contractModal.invoiceNumber }}
              </div>
              <div style="margin-top:10px;margin-bottom:10px;align-items: flex-end;align-content: flex-end;">
                N° FACTURE COMPAGNIE :
                {{ this.contractModal.companyInvoiceNumber }}
              </div>
            </div>
            <div
              style="border-bottom:2px solid black;border-top:2px solid black;padding-top:20px;padding-bottom:20px;margin-bottom:20px;">
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                    Police N° :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.policeNumber }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                    Branche :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.product }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                    Catégorie :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.category }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                    Type d'avenant :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.actionType }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;width: 180px;margin-top:10;margin-bottom:90;">
                    Numéro d'avenant :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.plugged }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                    Période du :
                  </div>
                  <div style="margin-top:10;margin-bottom:90;display:flex;flex-direction:row;">
                    {{ this.contractModal.effectDate }}
                    <div style="margin-left: 20px;margin-right: 20px;">au</div>
                    {{ this.contractModal.dueDate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="border-bottom:2px solid black;margin-top:10px solid black;">
              <div class="column" style="background-color:#fff;  float: left;
      width: 20%;  padding-left:10px;">
                <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                  Prime nette
                </div>
                <p>{{ this.contractModal.netPrime }}</p>
              </div>
              <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                  FGA
                </div>
                <p>{{ this.contractModal.TACAVA }}</p>
              </div>
              <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
     ">
                <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                  TAXE
                </div>
                <p>{{ this.contractModal.TE }}</p>
              </div>
              <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                  CEDEAO
                </div>
                <p>{{ this.contractModal.TVA }}</p>
              </div>
              <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                  PRIME TOTALE
                </div>
                <p>{{ this.contractModal.totalPrime }}</p>
              </div>
            </div>
            <div style="margin-top:25px">Facture arrêtée à la somme de :</div>
            <div style="margin-top:10px">
              "{{ this.contractModal.letterTotalPrime }}"
            </div>
            <div style="margin-top:20px">Cotonou, le {{ this.today }}</div>
            <div
              style="margin-top:0px;margin-bottom:30px;justify-content:flex-end;align-content:flex-end;align-items:flex-end;display:flex;flex-direction: column; margin-right:40px">
              <div>Pour DAYO GRAS SAVOYE BENIN</div>
              <br />
            </div>
            <br /><br /><br /><br /><br /><br /><br /><br /><br />
            <section style="text-align:center;font-size:8px;">
              <b style="color:#0482fb">Société de courtage en assurances </b>
              <br />SA AU CAPITAL DE 25.000.000 DE FRANCS CFA RCCM RB/COT /07B
              656 N° INSAE 2958200680733 - IFU 3200700020313 - Agrément N° 233
              /MF /DC /DGAE /DCA du 13/11/1995 <br />
              Garantie Financière et Assurance de Responsabilité Civile
              Professionnelle conformes aux articles 524 et 537 du code CIMA -
              Boulevard Marina, carré 4236 - 01 BP 6901 <br />
              COTONOU - Tél : (229) 21 30 31 30 / 25 30 E-mail :
              administration@bj.askgs.africa
            </section>
          </div>
        </section>
      </v-card>
    </v-dialog>
    <v-dialog v-model="printDeclarations" width="1000px">
      <v-card style="border-top: 10px solid #0482fb">
        <section style="margin-right:50px;margin-left:50px; padding-bottom:50px;padding-top:50px;">
          <v-row>
            <v-spacer></v-spacer>
            <v-btn color="error" class="mt-5 ml-2 mr-2 white--text" :loading="loading ? '#0482fb' : null" pill
              @click="generateReports()">Imprimer sous format PDF</v-btn>
          </v-row>

          <div id="document" ref="documents">
            <div
              style="display: flex;flex-direction: row;margin-Top:40px;border-Bottom:2px solid black;padding-bottom:20px;">
              <div style="background-color:white;">
                <img src="../assets/logo.jpg" alt="DAYO Gras Savoye" width="150" height="70" />
              </div>
              <div style="width:100%;display: flex;background-color:white;justify-content:center;align-items:center;">
                <div style="display: flex;flex-direction:column;">
                  <div style="font-size:20px;font-Weight:bold ; background-color:white;">
                    DAYO GRAS SAVOYE BENIN
                  </div>
                  <div style="background-color:white;">
                    Courtier en assurances
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px">
              <div style="font-weight:bold;margin-top:10;margin-bottom:90;margin-right:40px;">
                CLIENT N° :
              </div>
              <div style="margin-top:10;margin-bottom:90">
                {{ this.contractModal.customerNumber }}
              </div>
            </div>
            <div style="border-bottom:2px solid black;padding-bottom:20px;">
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Assureur :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{ this.contractModal.company }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Adresse :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{
                      this.contractModal.companyObject &&
                      this.contractModal.companyObject.address
                      ? this.contractModal.companyObject.address
                      : ""
                    }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    Province :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{
                      this.contractModal.companyObject &&
                      this.contractModal.companyObject.province
                      ? this.contractModal.companyObject.province
                      : ""
                    }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    N.I.F :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{
                      this.contractModal.companyObject &&
                      this.contractModal.companyObject.NIF
                      ? this.contractModal.companyObject.NIF
                      : ""
                    }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    STAT :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    {{
                      this.contractModal.companyObject &&
                      this.contractModal.companyObject.STAT
                      ? this.contractModal.companyObject.STAT
                      : ""
                    }}
                  </div>
                </div>
              </div>
              <div style="display:flex;flex-direction:row;">
                <div
                  style="display:flex;flex-direction:row;margin-top:10px;margin-bottom:10px;width:49%;background:white;justify-content:flex-end; align-items:flex-end;">
                </div>
                <div
                  style="display:flex;flex-direction:row;width:48%;background:white;justify-content:flex-start; align-items:flex-start;">
                  <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 120px;">
                    RCS :
                  </div>
                  <div style="margin-top:10;margin-bottom:90">
                    <div style="margin-top:10;margin-bottom:90">
                      {{
                        this.contractModal.companyObject &&
                        this.contractModal.companyObject.RCA
                        ? this.contractModal.companyObject.RCA
                        : ""
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top:10px;margin-bottom:10px">
                FACTURE N° : {{ this.contractModal.invoiceNumber }}
              </div>
              <div
                style="border-bottom:2px solid black;border-top:2px solid black;padding-top:20px;padding-bottom:20px;margin-bottom:20px;">
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;;">
                      Quittance DAYO GS:
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.receiptNumber }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;;">
                      Quittance Compagnie:
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.companyReceiptNumber }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Souscripteur :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.name }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Police N° :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.policeNumber }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Branche :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.product }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Catégorie :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.category }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Type d'avenant :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.actionType }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Numéro d'avenant :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.plugged }}
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-direction:row;">
                  <div
                    style="display:flex;flex-direction:row;width:75%;background:white;justify-content:flex-start; align-items:flex-start;">
                    <div style="font-weight:bold;margin-top:10;margin-bottom:90;width: 180px;">
                      Période du :
                    </div>
                    <div style="margin-top:10;margin-bottom:90">
                      {{ this.contractModal.effectDate }} au
                      {{ this.contractModal.dueDate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="border-bottom:2px solid black;margin-top:10px solid black;">
                <div class="column" style="background-color:#fff;  float: left;
      width: 20%;  padding-left:10px;">
                  <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                    Prime nette
                  </div>
                  <p>{{ this.contractModal.netPrime }}</p>
                </div>
                <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                  <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                    Taux de commision
                  </div>
                  <p>{{ this.contractModal.commissionRate }}</p>
                </div>
                <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
     ">
                  <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                    Montant commission
                  </div>
                  <p>{{ this.contractModal.commission }}</p>
                </div>
                <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                  <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                    Commission CEDEAO
                  </div>
                  <p>{{ this.contractModal.TVA }}</p>
                </div>
                <div class="column" style="background-color:#fff;  float: left;
      width: 20%;
      ">
                  <div style="font-weight:bold;border-bottom:2px solid black;padding-bottom:10px;">
                    Commission TTC
                  </div>
                  <p>{{ this.contractModal.commissionTTC }}</p>
                </div>
              </div>
              <div style="margin-top:15px">Facture arrêtée à la somme de :</div>
              <div style="margin-top:10px">
                "{{ this.contractModal.letterCommissionTTC }}"
              </div>
              <div style="margin-top:10px">Cotonou, le {{ this.today }}</div>
              <div
                style="margin-top:0px;margin-bottom:30px;justify-content:flex-end;align-content:flex-end;align-items:flex-end;display:flex;flex-direction: column; margin-right:40px">
                <div>Pour DAYO GRAS SAVOYE BENIN</div>
                <br />
              </div>
              <br /><br /><br /><br /><br /><br /><br /><br /><br />
              <section style="text-align:center;font-size:10px;">
                <b style="color:#0482fb">Société de courtage en assurances </b>
                <br />SA AU CAPITAL DE 25.000.000 DE FRANCS CFA RCCM RB/COT /07B
                656 N° INSAE 2958200680733 - IFU 3200700020313 - Agrément N° 233
                /MF /DC /DGAE /DCA du 13/11/1995 <br />
                Garantie Financière et Assurance de Responsabilité Civile
                Professionnelle conformes aux articles 524 et 537 du code CIMA -
                Boulevard Marina, carré 4236 - 01 BP 6901 <br />
                COTONOU - Tél : (229) 21 30 31 30 / 25 30 E-mail :
                administration@bj.askgs.africa
              </section>
            </div>
          </div>
        </section>
      </v-card>
    </v-dialog>
    <!-- facture dialoge-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="linkFacture" max-width="500px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h5">Liaison compagnie & DAYO GS</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-col cols="12" md="12">
                  <v-text-field outlined color="#0482fb" v-model="contractModal.companyInvoiceNumber"
                    label="Numéro facture compagnie"></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field outlined color="#0482fb" v-model="contractModal.companyReceiptNumber"
                    label="Numéro quittance compagnie"></v-text-field>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error " text @click="linkFacture = false">
                Fermer
              </v-btn>
              <v-btn color="success " :loading="loading ? '#0482fb' : null" class="ml-5" @click="factureLinkAdd">
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { addFile, updateFile } from "@/api/admin";
import { invoiceUpdate } from "@/api/user";
import html2pdf from "html2pdf.js";
import {
  cancelContract,
  createDeclaration,
  updateContract,
  addContract,
} from "@/api/user.js";

export default {
  name: "production",
  components: {},
  data: () => ({
    perssonel: [],
    printDeclaration: false,
    printDeclarations: false,
    items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
    natureprospect: ["Physics", "Entreprise"],

    contractDialog: false,
    headers: [
      {
        text: "Actions",
        width: "100px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "Numéro facture DAYO GS",
        width: "200px",
        // align: "start",
        value: "invoiceNumber",
      },
      {
        text: "Numéro facture Compagnie",
        width: "200px",
        // align: "start",
        value: "companyInvoiceNumber",
      },
      { text: "Nom / Raison sociale", width: "200px", value: "name" },
      { text: " Numéro client", width: "200px", value: "customerNumber" },
      { text: "Prime nette", width: "200px", value: "netPrime" },
      { text: "Prime TTC", width: "200px", value: "totalPrime" },
      { text: "Nature", width: "200px", value: "nature" },
      { text: "Adresse", width: "200px", value: "location" },
      { text: "Ville", width: "200px", value: "city" },
      { text: "NIF", width: "200px", value: "NIF" },
      { text: "STAT", width: "200px", value: "STAT" },
      // { text: "Branche", value: "plugged" },
      { text: "RCS", width: "200px", value: "RCA" },
      { text: "Numéro police", width: "200px", value: "policeNumber" },
      { text: "Catégori", width: "200px", value: "category" },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Type d'avenant", width: "200px", value: "actionType" },
    ],
    contrat: [
      {
        name: "gras savoye",
        company: "NSIA",
        endorsementType: "Affaire nouvelle",
        policeNumber: "2021445588",
        endorsementNumber: "2020114455",
        plugged: "Automobile",
        effect: "22/08/2022",
        dueDate: "31/12/2022",
        primeTTC: "1500000",
      },
    ],
    currentProduct: null,
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Prérogation",
      "Changement d'immatriculation",
    ],
    proposedProductNameList: [],
    companyNameList: [],
    productNameList: [],
    coinsuranceCompanyNameList: [],
    CommercialNameList: [],
    prospectsNameList: [],
    Contract: "",
    today: new Date()
      .toLocaleDateString()
      .substr(0, 10)
      .split("-")
      .join("/"),
    contractModal: {
      accessory100: 0,
      accessory50: 0,
    },
    incorporationModal: {},
    regulationClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },
    pbClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },

    coinsuranceModal: [
      {
        shareRate: 0,
        company: "",
        observation: "",
      },
    ],
    customerReturnDialog: false,
    categorie: [],
    companyReturnDialog: false,
    linkFacture: false,
    contratsearchData: "",
    companyReturnModal: {},
    fileName: "",
    product: "",
    policeNumber: "",
    plugged: "",
    company: "",
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    declarationModal: [],
    dialogDelete: false,
    cancelDialog: false,
    sinisterDialog: false,
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    fileDialog: false,
  }),

  mounted() {
    this.initQuotingRequest();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters([
      "Files",
      "QuotingRequests",
      "ContractsList",
      "Products",
      "Companies",
      "Facture",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    contractModal() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        this.contractModal.commercial = defaultMethods.getItemName(
          this.Users.docs,
          this.contractModal.commercial
        );

        // this.contractModal.dueDate =
        //   this.contractModal.dueDate
        // this.contractModal.effectDate =
        //   this.contractModal.effectDate
        // this.contractModal.paymentDate =
        //   this.contractModal.paymentDate

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  methods: {
    ...mapActions([
      "getQuotingRequests",
      "getContracts",
      "postSearchContrat",
      "getProducts",
      "getCompanies",
      "getFacture",
      "getFiles"
    ]),

    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    showAllFillData() {
      this.initQuotingRequest();
      //alert(this.showAllFil);
    },
    closeCancel() {
      this.cancelModal = {};
      this.cancelDialog = false;
    },
    async saveCancelContract() {
      this.loading = true;
      try {
        // add

        await cancelContract({ id: this.contractModal._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.canceledSuccessfully("Ce contrat")
        );
        this.closeCancel();
        this.initQuotingRequest();
      } catch (error) {
        // alert(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    startNewContract(item) {
      //alert(this.Contract.productName)

      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;

        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }
      this.seedCtr(item);
      this.contractDialog = true;

      this.contractModal.isNew = true;
    },
    seedCtr(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.contractModal.isNew = true;
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
    },
    initCancelContract(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.cancelDialog = true;
    },
    async initQuotingRequest() {
      this.loading = true;
      try {
        await this.getFacture({
          periodStartDate: this.periodStartDate,
          periodEndDate: this.periodEndDate,
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          customerNumber: this.customerNumber,
          invoiceNumber: this.invoiceNumber,
          companyInvoiceNumber: this.companyInvoiceNumber,
        });
        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },

    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchContrat({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          company: this.company,
          contractEstablished: true,
          //withQuoting: true,
          actionType: this.actionType,
          withoutPeriod: this.showAllFil,
          effectStartDate: this.effectStartDate,
          effectEndDate: this.effectEndDate,
          dueStartDate: this.dueStartDate,
          dueEndDate: this.dueEndDate,
          avenantList: this.avenantList,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    generateReport() {
      html2pdf(this.$refs.document, {
        margin: 0.3,
        filename: "Réclamation_prime.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          scrollX: 0,
          scrollY: 0,
        },

        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
    },
    generateReports() {
      html2pdf(this.$refs.documents, {
        margin: 0.3,
        filename: "commission.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
    },
    onEnter: function () {
      this.initQuotingRequest();
    },
    getSinisterDeclaration(item) {
      this.declarationModal.contentID = item._id;

      this.sinisterDialog = true;
    },
    async cashIn() {
      this.$refs.form.validate();

      if (this.$refs.form.validate()) {
        this.saveDeclaration();
      }
    },
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          sinisterCompanyNumber: this.declarationModal.sinisterCompanyNumber,
          circumstance: this.declarationModal.circumstance,
          dateOfOccurrence: this.declarationModal.dateOfOccurrence,
          declarationDate: this.declarationModal.declarationDate,
          companyDispatchDate: this.declarationModal.companyDispatchDate,
          driverName: this.declarationModal.driverName,
          conductiveContact: this.declarationModal.conductiveContact,
          registrationValidationDate: this.declarationModal
            .registrationValidationDate,
          PSAP: this.declarationModal.PSAP,
          disasterObject: this.declarationModal.disasterObject,
          insuredBodilyInjury: this.declarationModal.insuredBodilyInjury,
          materialDamageInsured: this.declarationModal.materialDamageInsured,

          observation: this.declarationModal.observation,
          // file: this.File._id,
        };
        if (this.declarationModal.dateOfOccurrence != "") {
          // add
          await createDeclaration({
            schema,
            id: this.declarationModal.contentID,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Declaration")
          );
          this.closeDeclaration();
          this.initQuotingRequest();
        } else {
          defaultMethods.dispatchError("Date survenance requis");
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.fileModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.fileModal.name,
              prospects: this.fileModal.prospects,
              phone: this.fileModal.phone,
              email: this.fileModal.email,
              nature: this.fileModal.nature,
              location: this.fileModal.location,
              description: this.fileModal.description,
              activityField: this.fileModal.activityField,
              birthday: this.fileModal.birthday,
              // proposedProducts: this.fileModal.proposedProducts,
            },
            id: this.fileModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        } else {
          // add
          await addFile(this.fileModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.fileModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          // commercial: defaultMethods.getItemId(
          //   this.Users.docs,
          //   this.contractModal.commercial
          // ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          // paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          // commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        if (!this.contractModal.isNew) {
          // update
          await updateContract({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initQuotingRequest();
        } else {
          // add
          schema.product = this.Contract.product;
          schema.fromContract = this.Contract._id;
          // schema.product = defaultMethods.getItemId(
          //   this.File.proposedProducts,
          //   this.currentProduct
          // );
          schema.file = this.File._id;
          await addContract({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    successSaveContract() {
      this.initQuotingRequest();
      this.closeContract();
    },
    closeContract() {
      this.contractDialog = false;
      this.seedCtr();
      this.initQuotingRequest();
      // this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    editItemFormat(item) {
      item = defaultMethods.arrayFieldsToInteger(item);
      this.contractModal.totalPrime = item.totalPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.cdeaoPrime = item.cdeaoPrime;
      this.contractModal.accessory100 = item.accessory100;
      this.contractModal.accessory50 = item.accessory50;
    },
    editItem(item) {
      this.contractModal = Object.assign({}, item);

      this.printDeclaration = true;
    },
    editItems(item) {
      this.contractModal = Object.assign({}, item);

      this.printDeclarations = true;
    },
    linkModalFacture(item) {
      this.contractModal = {};
      this.contractModal = Object.assign({}, item);

      this.linkFacture = true;
    },
    async factureLinkAdd() {
      this.loading = true;
      try {
        const schema = {
          companyInvoiceNumber: this.contractModal.companyInvoiceNumber,
          companyReceiptNumber: this.contractModal.companyReceiptNumber,
        };

        //  update
        await invoiceUpdate({
          schema,
          id: this.contractModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.linkFacture = false;
        this.initQuotingRequest();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addProspect() {
      this.editedIndex = -1;
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
